<template>
  <!-- :src="`${FrontendPath}/public/modules/101.jpg`" -->
  <v-jumbotron
    style="min-width:0% !important; height:80vh;"
    :gradient="gradient"
    dark
    :src="`${FrontendPath}/public/modules/101.jpg`" 
  >
    <v-container fill-height>
      <v-layout align-center>
        <v-flex text-xs-center>
          <div class="textDiv " >
             <v-avatar>
                <v-icon>check_circle</v-icon>
              </v-avatar>
            {{ moduleName }}
            <!-- {{ $route.name }} -->
          </div>

        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>
</template>

<script>
import { FrontendPath } from "../../vuex/api";

export default {

  data () {
    return {
      FrontendPath:FrontendPath,
      gradient: 'to top right, rgba(70, 152, 85, .4), rgba(21, 101, 192, 1)',
    }
  },

  computed: {
    moduleName() {
      //return 'Welcome to '+ localStorage.getItem("module");
      return 'Welcome to '+ this.$store.getters.GET_MODULE_NAME;
    }
  }

};
</script>

<style scoped>
.v-jumbotron__image {
    min-width: 0px !important;
}
.textDiv{
  background: transparent !important;
  border: 1px solid currentcolor;
  font-size: 25px;
  border-radius: 28px;
  padding-right: 13px;
  display: inline-flex;
  align-items: center;
  letter-spacing: -0.02em !important;
  cursor: pointer;
}
.textDiv:hover{
  background-color:#7A97C5 !important;  
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/project_info.vue